import React from 'react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {GameJackpotComponent} from '../../../../game-jackpot/game-jackpot.component';
import {SectionTitleBox} from '../../boxes/section-title/section-title.box';
import {GameJackpotPreviewBox} from './boxes/game-jackpot-preview/game-jackpot-preview.box';
import {JackpotAmountPreviewBox} from './boxes/jackpot-amount-preview/jackpot-amount-preview.box';

export interface GameJackpotPreviewComponentProps {
  gameType: number;
}

export class GameJackpotPreviewComponent extends OrbitComponent<GameJackpotPreviewComponentProps> {

  render() {
      //className={'game-info-jackpot game-preview'}
    return (
      <GameJackpotPreviewBox className='cy-game-jackpot-preview'>
        <SectionTitleBox>
          {this.services.translation.translate('GAME_JACKPOT')}
        </SectionTitleBox>
        <GameJackpotComponent className='cy-game-jackpot-preview-amount' box={JackpotAmountPreviewBox} gameType={this.props.gameType}/>
      </GameJackpotPreviewBox>
    )
  }
}


